import {environment} from 'src/environments/environment';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {AppComponent} from '../../app.component';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {sleep} from '../../../smoothr-web-app-core/utils/utils';
import Table from '../../../smoothr-web-app-core/models/Table';
import {Api} from '../../../smoothr-web-app-core/api/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-scan-qr',
	templateUrl: './scan-qr.component.html',
	styleUrls: ['./scan-qr.component.scss']
})
export class ScanQrModal implements OnInit {
	scanning = true;
	loading = false;
	venue: Venue;

	constructor(
		private snackBarCtrl: MatSnackBar,
		private router: Router,
		private modalCtrl: ModalController,
		public translate: TranslateService
	) {}

	/**
	 * returns table number
	 */
	static async show(modalCtrl: ModalController, venue: Venue): Promise<Table> {
		const resultScan = await modalCtrl.create({
			component: ScanQrModal,
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			componentProps: {
				venue
			}
		});
		await resultScan.present();
		const res = (await resultScan.onDidDismiss()).data;
		await sleep(100);
		return res;
	}
	ngOnInit() {
		// console.log(environment.webAppUrl + '/scan-qr/table/1');
		// this.scanSuccessHandler(environment.webAppUrl + '/scan-qr/table/1');
	}
	close() {
		this.modalCtrl.dismiss();
	}

	startScanning() {
		this.scanning = true;
	}

	stopScanning() {
		this.scanning = false;
	}

	scanSuccessHandler($event: string) {
		if (this.loading) {
			return;
		}
		const tableNumber = ScanQrModal.tableNumberFromScan($event);
		if (!tableNumber) {
			// not one of our table codes - keep the scanner running instead of
			// dropping the user out of the eat-in flow
			this.snackBarCtrl.open(this.translate.instant('scan_qr.invalid_code'), null, {
				duration: 2000
			});
			return;
		}
		this.loading = true;
		this.snackBarCtrl.open(this.translate.instant('scan_qr.reserving'), null, {
			duration: 2000
		});
		this.stopScanning();
		this.takeOverOrder(tableNumber);
	}

	/**
	 * Table codes look like <webAppUrl>/scan-qr/table/<number>. Anything else is
	 * some other QR code that happened to be in front of the camera.
	 */
	static tableNumberFromScan(scanned: string): string | null {
		if (!scanned) {
			return null;
		}
		const match = /\/scan-qr\/table\/([^\/?#]+)/.exec(scanned.trim());

		return match ? match[1] : null;
	}

	async takeOverOrder(tableNumber: string) {
		try {
			const table = (await Api.getTable(this.venue._id, tableNumber)).data;
			if (!table) {
				throw new Error('Table ' + tableNumber + ' not found');
			}
			await this.modalCtrl.dismiss(table);

			return;
		} catch (e) {
			console.log(e);
			this.snackBarCtrl.dismiss();
			this.snackBarCtrl.open(this.translate.instant('scan_qr.table_error'), null, {
				duration: 2000
			});
			// stay in the modal so the code can be scanned again
			this.loading = false;
			this.startScanning();
		}
	}
}
